import { Button } from "@material-ui/core";
import ProcedureIcon from "@material-ui/icons/Autorenew";
import React from "react";
import { withRouter } from "react-router-dom";

const ExecuteButton = ({ record, history }) => {
  const handleClick = () => {
    history.push({
      pathname: `/procedure/execute/${encodeURIComponent(record.name)}`,
      state: { record },
    });
  };

  return (
    <Button onClick={handleClick}>
      <ProcedureIcon style={{ color: "red" }} />
    </Button>
  );
};

export default withRouter(ExecuteButton);
